import { render, staticRenderFns } from "./wrong.vue?vue&type=template&id=04562db0&scoped=true&"
import script from "./wrong.vue?vue&type=script&lang=js&"
export * from "./wrong.vue?vue&type=script&lang=js&"
import style0 from "./wrong.vue?vue&type=style&index=0&id=04562db0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04562db0",
  null
  
)

export default component.exports